// extracted by mini-css-extract-plugin
export default {"container":"DeltaWarnings_container__IFyZo","warning":"DeltaWarnings_warning__s23DC","warningIcon":"DeltaWarnings_warningIcon__ZDm2c"};